// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__ncaPc","addWidgetButton":"Header_addWidgetButton__JSVor","dashboardTabs":"Header_dashboardTabs__3r6PU","active":"Header_active__2AWdr"};